module.exports = __webpack_public_path__ + "static/media/tuberlinlogo.77b62395.png";